import React from 'react';

import { FaqItem } from '@/shared/ui/FAQ';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from 'components/ui/accordion';
import { useTranslation } from 'react-i18next';
import { MEMBERSHIP_URL } from 'shared/constants';
import { createFaqSections } from 'shared/ui/FAQ';

type TabType = 'booking' | 'reservation' | 'moreHelp' | 'settling';

export function HomeFAQ({ activeTab }: { activeTab: TabType }) {
  const { t } = useTranslation('guide');
  const faqSections = createFaqSections(t);

  const bookingFaqs: FaqItem[] = faqSections.find((section) => section.id === 'booking')?.faqs || [];

  const reservationFaqs: FaqItem[] = faqSections.find((section) => section.id === 'reservation')?.faqs || [];

  const moreHelpFaqs: FaqItem[] = faqSections.find((section) => section.id === 'moreHelp')?.faqs || [];

  const settlingFaqs: FaqItem[] = [
    {
      id: 12,
      title: 'What services are available for settling in?',
      content: (
        <p className="text-[16px] leading-[1.5] tracking-[-0.022em] text-[#161C2D]/70">
          We offer various services to help you settle in Korea, including{' '}
          <a
            className="cursor-pointer text-primary underline underline-offset-2"
            href={MEMBERSHIP_URL}
            target="_blank"
            rel="noreferrer"
          >
            Checkmate Membership
          </a>{' '}
          for ongoing support during your stay.
        </p>
      ),
    },
  ];

  const getFaqsByTab = (tab: TabType): FaqItem[] => {
    switch (tab) {
      case 'booking':
        return bookingFaqs;
      case 'reservation':
        return reservationFaqs;
      case 'moreHelp':
        return moreHelpFaqs;
      case 'settling':
        return settlingFaqs;
      default: {
        const exhaustiveCheck: never = tab;
        throw new Error(`Unhandled tab type: ${exhaustiveCheck}`);
      }
    }
  };

  return (
    <div className="w-[656px] rounded-[10px] border-t-4 border-t-primary bg-white px-[36px] py-[36px] shadow-[0px_12px_30px_0px_rgba(0,0,0,0.06)]">
      <Accordion type="single" collapsible className="w-full">
        {getFaqsByTab(activeTab).map((faq, index) => (
          <AccordionItem
            key={faq.id}
            value={`item-${faq.id}`}
            className={`border-[#E7E9ED] ${index === getFaqsByTab(activeTab).length - 1 ? 'border-b-0' : ''}`}
          >
            <AccordionTrigger className="py-0 pb-[12px] pt-[28px] text-left text-[18px] font-semibold leading-[1.4] tracking-[-0.022em] text-[#161C2D] hover:no-underline">
              {faq.title}
            </AccordionTrigger>

            <AccordionContent className="pb-[28px] pt-0">
              <div className="text-[16px] leading-[1.5] tracking-[-0.022em] text-[#161C2D]/70">{faq.content}</div>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
